<span class="tag tag--{{ color }} tag--size-{{ size }}" [ngClass]="{ 'tag--close': close }" (click)="click()">
  @if (type === 'check') {
    <span class="tag__check">
      <app-icon class="tag__check-icon" [icon]="'check'" [width]="8"></app-icon>
    </span>
  }
  <ng-content></ng-content>
  @if (close) {
    <app-icon class="tag__close" [icon]="'close'" [width]="8" (click)="closeClick()"></app-icon>
  }
</span>
